<script>
	import Router from 'svelte-spa-router'
	import { routes } from './routes.js'
	import Tailwind from './Tailwind.svelte'
	import NavBar from './components/NavBar.svelte'
	import Footer from './components/Footer.svelte'
	import SessionExpiredModal from './components/SessionExpiredModal.svelte'
	import ErrorBox from './components/common/ErrorBox.svelte'
	import LoadingInfo from './components/LoadingInfo.svelte'
	import { onMount } from 'svelte'
	import { isMobile, locale, sessionExpiredModalShown, errorBox } from './store/stores.js'
	import { getHasAccess } from './login.js'
	import { updateLanguage, t } from './i18n'

	if(!$locale || $locale === "null") {
    	updateLanguage('fi')
  	}
	
	let promise = getHasAccess()
    onMount(() => {
		isMobile.set(window.innerWidth < 767)
    })

    window.addEventListener('resize', () => {
        isMobile.set(window.innerWidth < 767)
    })

</script>

<Tailwind />
{#await promise}
	<LoadingInfo />
{:then}
	<main class="min-h-screen flex flex-col">
		{#if $sessionExpiredModalShown}
			<SessionExpiredModal />
		{/if}
		<NavBar />
		<div class="flex-[1] mt-24">
			{#if $errorBox.title !== ''}
				<ErrorBox />
			{/if}
			<Router {routes}/>
		</div>
		<Footer />
	</main>
{/await}
